import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Divider,
  Text,
  VStack,
} from '@chakra-ui/react';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  isSaving?: boolean;
  onClose: () => void;
  onSaveAndExit: () => void;
  onLeaveWithoutSaving: () => void;
}

const UnsavedChangesModal = ({
  isOpen,
  isSaving = false,
  onClose,
  onSaveAndExit,
  onLeaveWithoutSaving,
}: UnsavedChangesModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md" closeOnOverlayClick={!isSaving} closeOnEsc={!isSaving}>
      <ModalOverlay />
      <ModalContent borderRadius="15px" px={3} py={8}>
        <ModalCloseButton
          color="#989898"
          p={8}
          _hover={{ color: 'inkBlue', bg: 'transparent' }}
          isDisabled={isSaving}
        />
        <ModalBody pt={4}>
          <Text textStyle="heading4" textAlign="center">
            Unsaved changes
          </Text>
          <Divider color="#E4E4E4" my={6} />

          <Text textAlign="center" fontSize="16px" mb={6}>
            You have unsaved changes. Save before leaving?
          </Text>
          <VStack spacing={4} w="full">
            <Button
              w="full"
              variant="gradient"
              size="sm"
              isLoading={isSaving}
              onClick={onSaveAndExit}
            >
              Save and exit
            </Button>
            <Button
              w="full"
              variant="outlineDark"
              _hover={{
                borderColor: 'dangerRed',
                color: 'dangerRed',
                bg: '#F8F8F8',
              }}
              size="sm"
              isDisabled={isSaving}
              onClick={onLeaveWithoutSaving}
            >
              Leave without saving
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default UnsavedChangesModal;
